// import { ConexionPlano } from '../domain/conexionPlano';
// import { NodoPlano } from '../domain/nodoPlano';

import { ConexionPlano } from 'interiores-mapa';
import { NodoPlano } from 'interiores-mapa';
import { Constantes } from './constantes';

export class ConexionFormulario {

	Id: string;
	Indicacion: string;

	CortadoTemporalmente: Boolean;

	IdNodoOrigen: string;
	IdNodoDestino: string;

	PESO_CONEXIONS: PesoFormulario[];

	CONEXION_PLANO: ConexionPlano = ConexionPlano.createInstance();
	NODO_PLANO_ORIGEN: NodoPlano = NodoPlano.createInstance();
	NODO_PLANO_DESTINO: NodoPlano = NodoPlano.createInstance();
	Idiomas: Map<string, ConexionNodoIdiomaFormulario> = new Map<string, ConexionNodoIdiomaFormulario>();

	// Objeto de Breeze
	ENTIDAD: any;

	constructor() {
		this.Id = '';
		this.Indicacion = '';
		this.CortadoTemporalmente = false;
		this.IdNodoOrigen = '';
		this.IdNodoDestino = '';
		this.PESO_CONEXIONS = [];

		this.CONEXION_PLANO = ConexionPlano.createInstance();
		this.NODO_PLANO_ORIGEN = NodoPlano.createInstance();
		this.NODO_PLANO_DESTINO = NodoPlano.createInstance();
		this.ENTIDAD = {};
	}


	fromConexionPlano(conexionPlano: ConexionPlano, nodoPlanoOrigen?: NodoPlano, nodoPlanoDestino?: NodoPlano): ConexionFormulario {

		this.CONEXION_PLANO = conexionPlano;
		this.NODO_PLANO_ORIGEN = nodoPlanoOrigen;
		this.NODO_PLANO_DESTINO = nodoPlanoDestino;

		if (this.CONEXION_PLANO.ENTIDAD) {
			this.fromENTIDAD(this.CONEXION_PLANO.ENTIDAD);
		}

		return this;
	}

	fromENTIDAD(ENTIDAD: any): ConexionFormulario{
		this.ENTIDAD = ENTIDAD;

		this.Id = this.ENTIDAD.Id;
		this.Indicacion = this.ENTIDAD.Indicacion ? this.ENTIDAD.Indicacion : '';
		this.CortadoTemporalmente = this.ENTIDAD.CortadoTemporalmente;
		this.IdNodoOrigen = this.ENTIDAD.IdNodoOrigen;
		this.IdNodoOrigen = this.ENTIDAD.IdNodoOrigen;
		this.IdNodoDestino = this.ENTIDAD.IdNodoDestino;
		this.IdNodoDestino = this.ENTIDAD.IdNodoDestino;

		this.ENTIDAD.PESO_CONEXIONS.forEach(element => {
			const peso = new PesoFormulario(element);
			this.PESO_CONEXIONS.push(peso);
		});

		this.ENTIDAD.IDIOMAS.forEach(element => {
			const aux = new ConexionNodoIdiomaFormulario(element);
			this.Idiomas.set(element.IDIOMA.Codigo, aux);
		});

		return this;
	}

}



export class PesoFormulario {

	Id: string;
	IdConexionNodo: string;
	IdPerfilMovilidad: string;

	Peso: any;

	// Objeto de Breeze
	ENTIDAD: any;
	PerfilMovilidad: any;

	constructor(peso_conexion?: any) {
		this.Id = '';
		this.IdConexionNodo = '';
		this.IdPerfilMovilidad = '';

		this.Peso = Constantes.PESO;

		// Objeto de Breeze
		this.ENTIDAD = {};
		this.PerfilMovilidad = {};

		if (peso_conexion !== undefined) {

			const entidad = peso_conexion;

			this.Id = entidad.Id;
			this.IdConexionNodo = entidad.IdConexionNodo ? entidad.IdConexionNodo : '';
			this.IdPerfilMovilidad = entidad.IdConexionNodo ? entidad.IdConexionNodo : '';

			if (entidad.Peso === Constantes.MAX_PESO) {
				this.Peso = '∞';
			}
			else{
				this.Peso = entidad.Peso;
			}

			this.PerfilMovilidad = entidad.PerfilMovilidad;
			this.ENTIDAD = entidad;
		}
	}
}

export class ConexionNodoIdiomaFormulario {

	Codigo: string = '';
	Indicacion: string = '';
	// TextoContenidos: string;
	constructor(conexionNodoIdioma?) {
		if (conexionNodoIdioma) {
			this.Codigo = conexionNodoIdioma.IDIOMA.Codigo ? conexionNodoIdioma.IDIOMA.Codigo : '';
			this.Indicacion = conexionNodoIdioma.Indicacion ? conexionNodoIdioma.Indicacion : '';
		}
		else{
			this.Codigo = '';
			this.Indicacion = '';
		}
	 }
}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/domain/ConexionFormulario.ts